import { useCallback, useState } from 'react'
import axios from 'axios'
import config from 'config'
import { orderBy } from 'lodash'

const useCars = () => {
  const [state, setState] = useState({
    isFetching: false,
    items: [],
    total: 0,
    error: null,
  })

  const setStartFetching = useCallback(() => {
    setState((s) => ({
      ...s,
      isFetching: true,
    }))
  }, [setState])

  const setSuccessFetching = useCallback(
    (items, total) => {
      setState((s) => ({
        ...s,
        items: items,
        total: total,
        isFetching: false,
        error: null,
      }))
    },
    [setState]
  )

  const fetchCars = useCallback(
    async (sessionId) => {
      setStartFetching()

      const results = await axios.get(
        `${config.apiBaseUrl}sessions/${sessionId}/cars`
      )

      setSuccessFetching(
        orderBy(results.data.body.items, ['title'], ['asc']),
        results.data.body.total
      )
    },
    [setStartFetching, setSuccessFetching]
  )

  return {
    cars: state.items,
    total: state.total,
    isFetching: state.isFetching,
    fetchCars,
  }
}

export default useCars
